import React, { useContext, useEffect } from "react";
import { getSortedHotelLabels, initialHotelFilter } from "./FilterTypes/HotelFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import MultiCompanyList from "components/Picker/CompanyPicker/MultiCompanyList";

const HotelFilter = () => {
  const title = site.currentEnvironment.functionGroups.hotel.singular;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("hotel", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedHotelLabels(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedHotels.length > 0,
    reset: () => initialHotelFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedHotels.map(h => h.companyId), b.selectedHotels.map(h => h.companyId))
  });
  useEffect(() => {
    setInitialValue("hotel", initialHotelFilter);
  }, []);

  const [selectedHotels, setSelectedHotels] = React.useState<server.dto.CompanySmall[]>(getValue("hotel").selectedHotels);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedHotels(getValue("hotel").selectedHotels);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("hotel", {
      selectedHotels
    });
    setPopupOpen(false);
  };

  if (!site.currentEnvironment.functionGroups.hotel.enabled) {
    return <></>;
  }

  return <div>
    <MultiPickerFilterPopup
      title={title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiCompanyList
        value={selectedHotels}
        onChange={setSelectedHotels}
        addressType="regular"
      />
    </MultiPickerFilterPopup>
  </div>;
};

export default HotelFilter;
